import type {ErrorService} from '@/domain/interfaces/ErrorService';

export class PublishErrorUseCase {
  constructor(private readonly errorService: ErrorService) {}

  execute = (error: Error) => {
    this.errorService.publish(error);
  };
}
